// Opens the print dialog once every image on the page has loaded (the logo, the signature and seal) — printing
// before that leaves them out of the paper/PDF. Gives up waiting after `maxWaitMs` and prints anyway.
export default function printWhenReady(maxWaitMs = 4000) {
  const pending = [...document.images].filter(img => !img.complete);
  if (!pending.length) {
    window.print();
    return () => {};
  }
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    window.print();
  };
  const timer = setTimeout(finish, maxWaitMs);
  let left = pending.length;
  pending.forEach(img => {
    const one = () => { left -= 1; if (left === 0) finish(); };
    img.addEventListener('load', one, { once: true });
    img.addEventListener('error', one, { once: true });
  });
  return () => { done = true; clearTimeout(timer); };
}
